import React, { Component } from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { Icon } from 'core/components';
import classNames from 'classnames';

const wrapperStyle = {
  position: 'relative',
  display: 'inline-block'
};

const Badge = styled.div`
  position: absolute;
  top: -6px;
  right: -11px;
  border-radius: 50%;
  padding: 0 3px;
  min-width: 14px;
  height: 14px;
  background-color: ${(props) => props.theme.colors[props.badgeColor] || props.theme.colors.kentik};

  // Outline makes the badge "cut-in" to the icon a bit.
  outline: 2px solid ${(props) => props.theme.colors[props.badgeOutlineColor] || 'transparent'};
  color: #fff;
  font-size: 10px;
  font-weight: 500;
  line-height: 14px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
`;

@observer
class CompoundIcon extends Component {
  static defaultProps = {
    iconName: '',
    icon: null,
    iconSize: 16,
    size: 16,
    secondaryIconName: '',
    secondaryIcon: null,
    secondaryIconSize: 16,
    secondaryIconStyle: {
      top: 0,
      right: -8,
      position: 'absolute'
    },
    badgeCount: null,
    badgeColor: 'kentik',
    badgeOutlineColor: 'transparent',
    showBadge: false
  };

  render() {
    const {
      iconName,
      icon,
      iconSize,
      size,
      className,
      secondaryIconName,
      secondaryIcon,
      secondaryIconStyle,
      secondaryIconSize,
      secondaryIconClassName,
      style,
      badgeCount,
      badgeColor,
      badgeOutlineColor,
      showBadge,
      ...iconProps
    } = this.props;

    // Support both old (iconName) and new (icon) APIs
    const primaryIcon = icon || iconName;
    const primaryIconSize = iconSize || size;
    const secondaryIconComponent = secondaryIcon || secondaryIconName;

    return (
      <div className="pt-icon-compound" style={{ ...wrapperStyle, ...style }}>
        <Icon icon={primaryIcon} iconSize={primaryIconSize} className={className} {...iconProps} />
        {secondaryIconComponent && (
          <Icon
            icon={secondaryIconComponent}
            iconSize={secondaryIconSize}
            className={classNames('pt-icon-secondary', secondaryIconClassName)}
            style={{ ...secondaryIconStyle, fontSize: secondaryIconSize }}
          />
        )}
        {(showBadge || (badgeCount !== null && badgeCount > 0)) && (
          <Badge badgeColor={badgeColor} badgeOutlineColor={badgeOutlineColor}>
            {badgeCount || ''}
          </Badge>
        )}
      </div>
    );
  }
}

export default CompoundIcon;
